import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/site/Reveal";
import { useT, useRoute } from "@/i18n";

export default function AboutSection() {
  const t = useT();
  const route = useRoute();
  return (
    <section className="py-24 md:py-32 lg:py-40 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-20">
          <Reveal className="lg:col-span-4">
            <p className="eyebrow">{t.about.eyebrow}</p>
            <h2 className="heading-display mt-4 text-3xl sm:text-4xl lg:text-5xl uppercase text-black">
              {t.about.title1}
              <br />
              <span className="text-[#C20E1A]">{t.about.title2}</span>
            </h2>
          </Reveal>
          <Reveal className="lg:col-span-8" delay={120}>
            <p className="text-base sm:text-lg text-black/80 leading-relaxed">{t.about.p1}</p>
            <p className="mt-6 text-base sm:text-lg text-black/80 leading-relaxed">{t.about.p2}</p>
            <p className="mt-8 text-2xl sm:text-3xl text-[#C20E1A] italic">{t.about.quote}</p>

            <Link
              to={route("about")}
              data-testid="about-learn-more"
              className="mt-10 inline-flex items-center gap-3 border-b-2 border-[#C20E1A] pb-2 text-[12px] uppercase tracking-[0.25em] font-bold text-black hover:text-[#C20E1A] transition-colors"
            >
              {t.common.learnMore} <ArrowRight size={14} />
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
